module.exports = __webpack_public_path__ + "static/img/toSend.82e7d80.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/toSend.png
// module id = IcMA
// module chunks = 21